import React from "react"

interface Props {
    isDisabled: boolean
    value: string | undefined
    setValue: React.Dispatch<React.SetStateAction<string | undefined>> | ((_value: string | undefined) => void)
    labelText: string | undefined
    isLabelRequired: boolean
}

const CustomDatePicker = ({
    isDisabled,
    value,
    setValue,
    labelText,
    isLabelRequired
}: Props) => {
    return (
        <React.Fragment>
            {
                labelText && (
                    <label className={"form-label " + (isLabelRequired ? 'required' : '')}>{labelText}</label>
                )
            }

            <input disabled={isDisabled} style={{ background: (isDisabled ? '#f1f1f4' : undefined), border: '1px solid #F1F1F4' }} value={value} onChange={(e) => setValue(e.target.value)} type="date" className="form-control form-control-solid" />
        </React.Fragment>
    )
}

CustomDatePicker.defaultProps = {
    isDisabled: false,
    labelText: undefined,
    isLabelRequired: false
}

export default CustomDatePicker;